import { LIST_ROWS_PER_PAGE } from '../../constants';

export const EVENT_TABS = {
  UPCOMING: 'upcoming',
  PAST: 'past',
  REVIEW: 'review',
  ARCHIVE: 'archive',
};

/** GET /admin/events?event_type=… — order matches list tabs (default: upcoming). */
export const EVENT_LIST_EVENT_TYPES = [EVENT_TABS.UPCOMING, EVENT_TABS.PAST, EVENT_TABS.REVIEW];

export const getEventListEventType = (tabIndex) =>
  EVENT_LIST_EVENT_TYPES[tabIndex] ?? EVENT_TABS.UPCOMING;

/**
 * Query params for GET /admin/events
 * @param {{ limit: number, page: number, eventType: string, categoryType?: string, search?: string }} options
 */
export const buildEventsListQueryParams = ({
  limit,
  page,
  eventType,
  categoryType = '',
  search = '',
}) => {
  const params = {
    limit,
    page,
    event_type: eventType,
  };

  if (categoryType) {
    params.types = categoryType;
  }

  if (search) {
    params.search = search;
  }

  return params;
};

export { EVENT_TYPE_FILTERS } from './eventTypes';

export const EVENT_VIEW_MODES = {
  LIST: 'list',
  GRID: 'grid',
};

export const EVENTS_PER_PAGE = LIST_ROWS_PER_PAGE;
